import { render, staticRenderFns } from "./404NotHeader.vue?vue&type=template&id=2753e29a&scoped=true"
import script from "./404NotHeader.vue?vue&type=script&lang=js"
export * from "./404NotHeader.vue?vue&type=script&lang=js"
import style0 from "./404NotHeader.vue?vue&type=style&index=0&id=2753e29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753e29a",
  null
  
)

export default component.exports